import request from '@/utils/request'

//Login
export function transactionhistory(page) {
  return request({ url: 'vtransaction', method: 'post', data: {'page': page} })
} 

export function getFifthPairOptionDetails() {
  return request({ url: 'v5thpairoptiondetails', method: 'post', data: {} })
} 

export function saveFifthPairOption(params) {
  return request({ url: 'savefifthpairoption', method: 'post', data: params })
} 


